
import { defineComponent, markRaw } from 'vue';
import Icon from '@ant-design/icons-vue';
import NetworkSvg from './svg/NetworkSvg.vue';

export default defineComponent({
  name: 'NetworkIcon',
  components: {
    Icon
  },
  props: {},
  data() {
    return {
      NetworkSvg: markRaw(NetworkSvg)
    };
  }
});
